const isProduction = process.env.NODE_ENV === 'production';

export const config = {
    // In production, this would be your Cloud Function / AWS Server URL
    // In development, it points to your local Python RAG engine
    AI_API_URL: process.env.REACT_APP_API_URL || (isProduction
        ? "https://pulsenote-ai.onrender.com/query"
        : "http://127.0.0.1:5000/query"),

    // OLLAMA (Local Fallback)
    OLLAMA_URL: "http://localhost:11434/api/chat",

    // GROQ (Cloud AI)
    GROQ_URL: "https://api.groq.com/openai/v1/chat/completions",
    GROQ_API_KEY: process.env.REACT_APP_GROQ_API_KEY // Must be set in .env
};
